import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import MarkedEditor from 'src/components/MarkedEditor';

import useStyles from './useStyles';

export const ContentSimple = ({
  className,
  index,
  content,
  onChange,
  onFocusChange,
  disabled,
  disableNewlines,
  hideMarks,
  addons,
  setEditor,
  ...restProps
}) => {
  const styles = useStyles();

  const handleChange = useCallback(
    (value) => {
      onChange(value);
    },
    [onChange]
  );

  const handleFocusChange = useCallback(
    (value) => {
      if (onFocusChange) {
        onFocusChange(value, index);
      }
    },
    [onFocusChange, index]
  );

  return (
    <MarkedEditor
      className={cx(styles.root, className)}
      value={content}
      onChange={handleChange}
      onFocusChange={handleFocusChange}
      readOnly={disabled}
      disableNewlines={disableNewlines}
      hideMarks={hideMarks}
      addons={addons}
      setEditor={setEditor}
      {...restProps}
    />
  );
};

ContentSimple.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  content: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onChange: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func,
  disabled: PropTypes.bool,
  disableNewlines: PropTypes.bool,
  hideMarks: PropTypes.bool,
  addons: PropTypes.arrayOf(PropTypes.elementType),
  setEditor: PropTypes.func,
};

ContentSimple.defaultProps = {
  className: null,
  index: null,
  onFocusChange: null,
  disabled: false,
  disableNewlines: false,
  hideMarks: false,
  addons: [],
  setEditor: null,
};
